/**
 * @fileoverview MediaQueryList に addEventListener() を生やす PolyFill
 */


/**
 * ブラウザネイティブの window.matchMedia
 */
// もし `Property 'origMatchMedia_' does not exist on type 'Window & typeof globalThis'`
// という TypeScript Error が出る場合は、下記 URL の対応が必要。
// https://bobbyhadz.com/blog/typescript-property-does-not-exist-on-type-window
const origMatchMedia = window.origMatchMedia || (window.origMatchMedia = window.matchMedia.bind(window))


// MediaQueryList.addEventListener() が存在しない様子であれば、
// それを取り付けた PolyFill 版を新たな window.matchMedia に据える。
// (やむなくブラウザネイティブオブジェクトを上書きする)
const mqlTest = origMatchMedia('all')
const isFunction = (arg: any) => (typeof arg === 'function')
const needsPolyFill = !isFunction(mqlTest.addEventListener) || isFunction(mqlTest.addListener)
if (needsPolyFill) {
  window.matchMedia = mediaQuery => {
    const mql = origMatchMedia(mediaQuery)
    mql.addEventListener    = (type: string, listener: EventListener) => type === 'change' && mql.addListener(listener)
    mql.removeEventListener = (type: string, listener: EventListener) => type === 'change' && mql.removeListener(listener)
    return mql
  }
}
